/**
 * Execute GTAG directive if available.
 */
function invokeGtag(callback) {
  const {
    gtag
  } = window;
  if (gtag) {
    callback(gtag);
  }
}
export { invokeGtag };